import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";

function ScrollToTopArrow() {
	const [isVisible, setIsVisible] = useState(false);
	const heightToHideFrom = 500;

	useEffect(() => {
		const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
		if (winScroll >= heightToHideFrom) {
			setIsVisible(true);
		}
	}, []);

	useEffect(() => {
		const listenToScroll = () => {
			const winScroll = document.body.scrollTop || document.documentElement.scrollTop;

			if (winScroll < heightToHideFrom) {
				isVisible && setIsVisible(false);
			} else {
				setIsVisible(true);
			}
		};

		window.addEventListener("scroll", listenToScroll);
		return () => {
			window.removeEventListener("scroll", listenToScroll);
		};
	}, [isVisible]);

	const scrollToTop = () => {
		window.scrollTo({ top: 0, behavior: "smooth" });
	};

	return (
		<div
			className={`stta-container ${isVisible ? "opacity-1 visible" : "opacity-0 invisible"}`}
			onClick={scrollToTop}
		>
			<FontAwesomeIcon icon={faArrowUp} />
		</div>
	);
}

export default ScrollToTopArrow;
